import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOverlay = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 11,
	viewBox: "0 0 10 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.42384 6.59989C9.55112 6.47261 9.61422 6.31723 9.61369 6.13427L9.59513 1.42456C9.59937 1.25168 9.53468 1.09789 9.4021 0.965307C9.27111 0.83432 9.11626 0.768561 8.9386 0.768031L4.22942 0.75C4.04646 0.753712 3.89214 0.81788 3.76699 0.943034C3.64448 1.06554 3.58138 1.2188 3.57766 1.40176L3.57926 1.94427C3.57979 2.12828 3.64448 2.28314 3.77282 2.41147C3.90116 2.53981 4.05654 2.60504 4.24003 2.60504L6.35916 2.61352L3.8232 5.14948C3.69805 5.27463 3.64183 5.42206 3.65509 5.59017C3.66729 5.75934 3.73782 5.90836 3.86616 6.0367L4.33018 6.50072C4.45852 6.62906 4.60753 6.69959 4.7767 6.71178C4.94534 6.72557 5.09224 6.66883 5.21739 6.54367L7.75335 4.00772L7.76555 6.13056C7.76078 6.30928 7.82495 6.4636 7.9554 6.59405C8.08639 6.72504 8.24018 6.78868 8.4189 6.78391L8.96194 6.78603C9.1449 6.78656 9.29869 6.72504 9.42384 6.59989Z",
			fill: "#0578BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.18779 9.195H2.01779C1.62794 9.195 1.31191 8.87897 1.31206 8.48926V5.32044C1.31206 4.93206 1.62588 4.61735 2.01368 4.615V3.54338C1.03956 3.54397 0.25 4.33368 0.25 5.30794V8.48279C0.25 9.45735 1.04015 10.2475 2.01471 10.2475H5.19103C6.15941 10.2475 6.94397 9.46676 6.95382 8.50059H5.8925C5.88618 8.885 5.57368 9.195 5.18779 9.195Z",
			fill: "#0578BE"
		})
	]
});
const ForwardRef = forwardRef(SvgOverlay);
export { ForwardRef as ReactComponent };
